import type React from 'react';

import type { RawButtonProps } from '../../buttons';
import { RawButton } from '../../buttons';

import styles from './PINButton.module.scss';

const PINButton: React.FC<RawButtonProps> = (props) => (
  <RawButton className={styles.button} variant="secondary" {...props} />
);

export default PINButton;
